module.exports = __webpack_public_path__ + "static/media/Primary.cf9e5746.svg";